<template>
  <div class="row">
      <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
        <div class="card mb-25 border-0 rounded-0">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
              <h4 class="position-relative text-black fw-bold mb-10">Informations générales</h4>
              <router-link to="/fournisseurs/liste-fournisseurs" 
              class=" btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour</router-link>
            </div>
            <table class="table">
              <tbody>
                <tr v-if="fournisseur?.statut">
                  <td>Statut :</td>
                  <td>{{ fournisseur.statut == 1 ? 'Personne physique' : 'Personne morale' }}</td>
                </tr>
                <tr v-if="fournisseur?.nomFournisseur">
                  <td>Nom :</td>
                  <td>{{ fournisseur?.nomFournisseur }}</td>
                </tr>
                <tr v-if="fournisseur?.prenomFournisseur">
                  <td>Prénom :</td>
                  <td>{{ fournisseur?.prenomFournisseur }}</td>
                </tr>
                <tr v-if="fournisseur?.adresseFournisseur">
                  <td>Adresse fournisseur :</td>
                  <td>{{ fournisseur?.adresseFournisseur }}</td>
                </tr>
                <tr  v-if="fournisseur?.email">
                  <td>Email :</td>
                  <td>{{ fournisseur?.email }}</td>
                </tr>
                <tr v-if="fournisseur?.telephoneFournisseur1">
                  <td>Téléphone 1 :</td>
                  <td>{{ fournisseur?.telephoneFournisseur1 }}</td>
                </tr>
                <tr v-if="fournisseur?.telephoneFournisseur2">
                  <td>Téléphone 2 :</td>
                  <td>{{ fournisseur?.telephoneFournisseur2 }}</td>
                </tr>
                
                <tr v-if="fournisseur?.raisonSociale">
                  <td>Raison sociale :</td>
                  <td>{{ fournisseur?.raisonSociale }}</td>
                </tr>
                <tr v-if="fournisseur?.ifu">
                  <td>Ifu :</td>
                  <td>{{ fournisseur?.ifu }}</td>
                </tr>
                <tr v-if="fournisseur?.denomination">
                  <td>Dénomination :</td>
                  <td>{{ fournisseur?.denomination }}</td>
                </tr>
                <tr v-if="fournisseur?.dateCreation">
                  <td>Date création :</td>
                  <td>{{ fournisseur?.dateCreation }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { Fournisseur } from "@/models/Fournisseur";
import { error, format_Date, showModal } from "@/utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ViewFournisseur",
  setup: () => {
    const route = useRoute();
    const fournisseur = ref<Fournisseur | null>(null);

    function getFournisseur(id: string) {
      return ApiService.get("/fournisseurs/", id)
        .then(({ data }) => {
          fournisseur.value = data.data; 
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    } 
    onMounted(() => {
      const id = route.params.id as string;
      getFournisseur(id);
    });

    return { 
      fournisseur,
      getFournisseur,
      format_Date,
     };
  },
});
</script>
